import { Button, BlankSlate as DesignSystemBlankSlate } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  hasReviewProcesses: boolean
  canCreateReviewProcesses: boolean
}

const BlankSlate = ({ hasReviewProcesses, canCreateReviewProcesses }: Props) => {
  const { navigation } = useNavigation()

  const text = hasReviewProcesses
    ? {
        title: i18n.t(`performance_process.analytics.datatable.blank_slate.no_data.title`),
        description: i18n.t(
          'performance_process.analytics.datatable.blank_slate.no_data.description'
        ),
      }
    : {
        title: i18n.t(`performance_process.analytics.datatable.blank_slate.no_analytics.title`),
        description: i18n.t(
          'performance_process.analytics.datatable.blank_slate.no_analytics.description'
        ),
      }

  return (
    <DesignSystemBlankSlate {...text} illustration="analytics-graph-lines" size="small">
      {!hasReviewProcesses && canCreateReviewProcesses && (
        <Button.Router iconName="add" to={navigation.performanceProcess.reviews.fullPath()}>
          {i18n.t('performance_process.analytics.datatable.blank_slate.no_analytics.create')}
        </Button.Router>
      )}
    </DesignSystemBlankSlate>
  )
}

export default BlankSlate
